import { useContext, useEffect, useImperativeHandle, useState } from "react";
import UserInfoInMedicalReports from "../../../../components/Reports/MedicalReports/UserInfoInMedicalReports";
import { UserContext } from "../../../../Context/UserContextAPI";
import { Link, useLocation, useParams } from "react-router-dom";
import useQueryFetch from "../../../../hooks/useQueryFetch";
import request from "../../../../utils/request";
import LoaderLayout from "./../../../../components/Layout/LoaderLayout";
import { medicalPathologyStatusCheck } from "./medicalPathologyCondtion";
import { statusCheckHandler } from "./pathologyStatusCheckHandler";

const MedicalPathology = ({ fromEntryPage, pathologyEntryRef }) => {
  // params and query params
  const { userId } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const queryData = queryParams.get("data") || 1;

  const { settingsData, accessPerm, currentUser } = useContext(UserContext);

  // user detail data fetch
  const { data: userDetailData, isLoading } = useQueryFetch(
    ["user", userId],
    () => request.getOne("user-details/test", userId)
  );
  const userDetail = userDetailData?.userDetail;

  // investigations data fetch
  const { data: investigations, isSuccess: isInvestigationsSuccess } =
    useQueryFetch(
      ["investigations", queryData, { role_id: userDetail?.user?.role_id }],
      () =>
        request.create(`reports/get-data/${queryData}`, {
          invIds:
            userDetail?.user?.role_id === 5
              ? userDetail?.investigation_id?.split(",")
              : userDetail?.package?.investigation_id?.split(",") || [],
        })
    );

  // pathology tests data fetch
  const { data: pathologyTests } = useQueryFetch(
    ["pathologyTests", userId],
    () => request.getOne("reports/pathology", userId)
  );

  // pathology comments data fetch
  const { data: pathologyComments } = useQueryFetch(
    ["pathologyComments", userId],
    () => request.getOne("reports/get-pathology-comments", userId)
  );
  //   console.log("pathologyComments", pathologyComments);

  // state
  const [pathologyReportData, setPathologyReportData] = useState([]);
  //   const [pathologyComment, setPathologyComment] = useState({
  //     user_id: userId,
  //     comments: "",
  //     status: 1,
  //     investigation_group_id: 2,
  //   });

  // use effects
  useEffect(() => {
    // Initialize pathologyReportData based on whether pathologyTests exist
    if (isInvestigationsSuccess) {
      const initialData = investigations?.map((investigation) => {
        if (pathologyTests?.length > 0) {
          // Find matching pathologyTest for the current investigation
          const matchedTest = pathologyTests?.find(
            (test) => test.investigation_id === investigation.id
          );

          // Determine the result and test_id based on matchedTest or default to the first investigation_test
          const result = matchedTest?.result?.replace(/<[^>]*>/g, "") || "";
          const test_id = matchedTest
            ? matchedTest.test_id
            : investigation.investigation_tests[0]?.id;

          return {
            user_id: userId,
            investigation_id: investigation.id,
            test_id: test_id,
            user_file: matchedTest ? matchedTest.user_file : "",
            result: result,
            created_by: currentUser?.f_name,
          };
        }

        // Default case when no pathologyTests exist
        return {
          user_id: userId,
          investigation_id: investigation.id,
          test_id: investigation.investigation_tests[0]?.id,
          user_file: "",
          result: "",
          created_by: currentUser?.f_name,
        };
      });
      // const { reports } = medicalPathologyStatusCheck(initialData, userId);
      setPathologyReportData(initialData);
    }
  }, [
    investigations,
    userId,
    pathologyTests,
    currentUser?.f_name,
    isInvestigationsSuccess,
  ]);

  // functions

  const handleOnChange = (event, testId) => {
    // setIsDataSaved(false);
    setPathologyReportData((previousReport) => {
      const updatedReport = previousReport.map((report) => {
        if (report?.test_id === testId) {
          return {
            ...report,
            result: event.target.value,
          };
        }
        return report;
      });
      return updatedReport;
    });
  };

  const handleNormalValue = () => {
    investigations?.forEach((investigation, index) => {
      setPathologyReportData((previousReport) => {
        const updatedReport = previousReport.map((report) => {
          if (report?.test_id === investigation?.investigation_tests[0]?.id) {
            if (investigation?.investigation_tests[0]?.info) {
              return {
                ...report,
                result: investigation?.investigation_tests[0]?.info?.replace(
                  /<[^>]*>/g,
                  ""
                ),
                status: 0,
              };
            }
          }
          return report;
        });
        setPathologyReportData(updatedReport);
        return updatedReport;
      });
    });

    // setIsDataSaved(false);
  };

  const savePathologyReport = async () => {
    console.log(pathologyReportData);
    // setLoading(true);
    try {
      const emptyResult = pathologyReportData.filter(
        (item) =>
          item.result === "" &&
          item.investigation_id !== 19 &&
          item.investigation_id !== 22
      ).length;
      const dashCount = pathologyReportData.filter(
        (item) =>
          item.result === "---" &&
          item.investigation_id !== 19 &&
          item.investigation_id !== 22
      ).length;
      // console.log(emptyResult, dashCount);
      // console.log(user?.package?.id === 2);
      let checkedValue = 0;
      if (userDetail?.package?.id !== 2) {
        if (emptyResult >= 1 || dashCount >= 3) {
          checkedValue = 1;
        }
      } else if (userDetail?.package?.id === 2) {
        checkedValue = 0;
      } else {
        checkedValue = 0;
      }

      const { status, pathologyRiskFactor, reports } = statusCheckHandler(
        pathologyReportData,
        userId
      );
      //   setPathologyReportData(reports);

      const combinedData = {
        pathologyComment: {
          //   ...pathologyComment,
          user_id: userId,
          comments: pathologyComments?.comments || "",
          investigation_group_id: 2,
          status,
        },
        pathologyRiskFactor: {
          ...pathologyRiskFactor,
          status: status,
        },
      };
      const postData = {
        pathologyReportData,
        isPathologyDoneValue: checkedValue,
        combinedData,
      };
      //   Save pathology status
      const pathologyStatusResponse = await request.create(
        `reports/save/pathology/save/all/${userId}`,
        postData
      );
      console.log("pathologyStatusResponse", pathologyStatusResponse);
      if (pathologyStatusResponse?.status === "OK") {
        await request.getOne(`reports/user-test-status`, userId);
        // toast.success(pathologyStatusResponse?.data?.data);
        // setLoading(false);
      }
    } catch (error) {
      console.error(error);
      //   setLoading(false);
      //   toast.error("Pathology Saved Failed");
    }
    // setLoading(false);
  };

  // button handler in ref for entry page
  useImperativeHandle(pathologyEntryRef, () => ({
    handleNormalValue,
    savePathologyReport,
  }));

  return (
    <LoaderLayout isPending={isLoading}>
      <div>
        <div className="card p-3 medical-pathology">
          <div className="row mb-2 bg-primary text-white px-2 py-2">
            <h6 className="mb-0">Medical Pathology Report</h6>
          </div>
          <div className="row justify-content-center h-100">
            {userDetail && !fromEntryPage && (
              <UserInfoInMedicalReports
                userDetail={userDetail}
                settingsData={settingsData}
              />
            )}
          </div>

          {/* main input field  */}

          <div className="bg-primary mt-1 p-3 px-4 rounded-3 text-light">
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(2, 1fr)",
                gap: "16px",
              }}
            >
              {isInvestigationsSuccess &&
                investigations?.map((investigation, index) => {
                  const isMaleAndPregnancyTest =
                    (userDetail?.gender?.name === "Male" ||
                      userDetail?.gender?.name === "male") &&
                    investigation?.name === "Pregnancy Test";
                  if (isMaleAndPregnancyTest) {
                    return null;
                  }
                  const report = pathologyReportData.find(
                    (report) =>
                      report?.test_id ===
                      investigation?.investigation_tests[0]?.id
                  );

                  const { reports: colorReports } = statusCheckHandler(
                    [
                      {
                        ...investigation,
                        investigation_id: investigation?.id,
                        result: report?.result,
                      },
                    ],
                    userId
                  );
                  const colorReport = colorReports[0];

                  // Determine the text color based on status
                  let textColorClass = "";
                  if (colorReport) {
                    if (colorReport.status === 2) {
                      // Fit
                      textColorClass = "text-success";
                    } else if (colorReport.status === 3) {
                      // Unfit
                      textColorClass = "text-danger";
                    } else if (colorReport.status === 4) {
                      // Held-up
                      textColorClass = "text-primary";
                    }
                  }
                  return (
                    <div
                      key={index}
                      className={`d-flex align-items-center fs-6`}
                    >
                      <label
                        htmlFor={`${investigation?.name?.toLowerCase()}`}
                        className="w-25"
                      >
                        {investigation?.name}
                      </label>
                      {investigation?.investigation_tests[0]?.value_type?.toLowerCase() ===
                      "dropdown" ? (
                        <select
                          name="dropdown"
                          value={report?.result}
                          className={`form-select w-75 ${textColorClass}`}
                          id={`${investigation?.name?.toLowerCase()}`}
                          onChange={(event) =>
                            handleOnChange(
                              event,
                              investigation?.investigation_tests[0]?.id
                            )
                          }
                        >
                          {investigation?.investigation_tests[0]?.dropdown_value
                            ?.split(",")
                            .map((v, index) => (
                              <option key={index} value={v}>
                                {v}
                              </option>
                            ))}
                        </select>
                      ) : (
                        <input
                          type="text"
                          id={`${investigation?.name?.toLowerCase()}`}
                          value={report?.result}
                          className={`form-control w-75 ${textColorClass}`}
                          onChange={(event) =>
                            handleOnChange(
                              event,
                              investigation?.investigation_tests[0]?.id
                            )
                          }
                        />
                      )}
                    </div>
                  );
                })}
            </div>
          </div>

          {/* next prev buttons and save button */}
          <div className="row mt-3">
            <div className="row mt-3">
              <div className="col-6">
                <div className="d-flex gap-2">
                  {userDetailData?.nextPage &&
                    !fromEntryPage &&
                    settingsData?.next_prev_button === 1 && (
                      <Link
                        to={`/dashboard/medical-reports/pathology/create/${userDetailData?.nextPage}?data=1`}
                        className="btn btn-primary"
                      >
                        Previous
                      </Link>
                    )}
                  {userDetailData?.previousPage &&
                    !fromEntryPage &&
                    settingsData?.next_prev_button === 1 && (
                      <Link
                        to={`/dashboard/medical-reports/pathology/create/${userDetailData?.previousPage}?data=1`}
                        className="btn btn-primary"
                      >
                        Next
                      </Link>
                    )}
                </div>
              </div>
              <div className="col-6">
                <div className="d-flex gap-2 justify-content-end">
                  {accessPerm(33, 22) && (
                    <button
                      className="btn btn-primary"
                      onClick={handleNormalValue}
                      ref={pathologyEntryRef}
                    >
                      Set Normal
                    </button>
                  )}

                  {!fromEntryPage && (
                    <button
                      className="btn btn-success px-2"
                      onClick={savePathologyReport}
                    >
                      Save Results
                    </button>
                  )}

                  {!fromEntryPage && (
                    <button
                      className="btn btn-outline-secondary"
                      onClick={() => {
                        window.close();
                      }}
                    >
                      Close
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LoaderLayout>
  );
};

export default MedicalPathology;
